import { cn } from '@repo/ui';
import Image from 'next/image';

export function Logo({ className }: { className?: string }): React.JSX.Element {
  return (
    <div
      className={cn(
        className,
        'flex items-center gap-2 text-xl font-bold whitespace-nowrap sm:text-2xl',
      )}
    >
      <Image src="/logo/svg/coolmate-logo.svg" alt="Cool Mate logo" width={32} height={32} />
      Cool Mate
    </div>
  );
}

export function Mark({ className }: { className?: string }): React.JSX.Element {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <Image src="/logo/svg/coolmate-logo.svg" alt="Cool Mate logo" width={24} height={24} />
    </div>
  );
}
